import { render, staticRenderFns } from "./ExpertYearAssessForm.vue?vue&type=template&id=27885b8b&scoped=true"
import script from "./ExpertYearAssessForm.vue?vue&type=script&lang=js"
export * from "./ExpertYearAssessForm.vue?vue&type=script&lang=js"
import style0 from "./ExpertYearAssessForm.vue?vue&type=style&index=0&id=27885b8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27885b8b",
  null
  
)

export default component.exports